import { MapStringTo } from "../../base-types";

/**
 * Interface for e-mail notification requests.
 */
export interface IMailRequest {
    /**
     * Gets or sets the name of the mail template to be used.
     */
    mailTemplateName: string;

    /**
     * Gets or sets the variables to be applied on the mail template.
     */
    variables: MapStringTo<unknown>;

    /**
     * Validates the mail request.
     */
    validate(): void;
}

/**
 * Base class for mail requests.
 */
export abstract class MailRequest implements IMailRequest {
    mailTemplateName: string;

    variables: MapStringTo<unknown> = {};

    abstract validate(): void;
}
